import { IKeyValueStorage } from './SessionStorageFactory';

// eslint-disable-next-line import/no-unused-modules
export default class PersistentStorageFactory {
	static create(): IKeyValueStorage {
		return localStorage;
	}
}

export const storage = (() => {
	return PersistentStorageFactory.create();
})();
